import { connect } from 'react-redux';

import { createPageConfig } from '../../entity/CreatePages/createPages';
import BaseComponent from '../../components/BaseComponent';

class CreatePages extends BaseComponent {
  constructor(props) {
    super(props);
    this.config = { ...createPageConfig };
    this.getResponse();
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(CreatePages);
